'use client'

import { ApolloLink } from '@apollo/client'
import { ApolloClient, ApolloNextAppProvider, InMemoryCache } from '@apollo/client-integration-nextjs'

import { API, API_PROXY, type Market } from '~/utils/api'

import { getApolloLinks } from '~/lib/apollo/links'

function makeClient(market: Market) {
  const apiURL = typeof window === 'undefined' ? API_PROXY[market] : API[market]

  return new ApolloClient({
    cache: new InMemoryCache(),
    link: ApolloLink.from(getApolloLinks({ apiURL })),
  })
}

export function ApolloWrapper({ children, market }: React.PropsWithChildren<{ market?: Market }>) {
  return <ApolloNextAppProvider makeClient={() => makeClient(market || 'pl')}>{children}</ApolloNextAppProvider>
}
